export var INCORRECT_PHONE_ERROR_MESSAGE = 'Указан некорректный номер телефона. Проверьте правильность ввода';